<template>

    <v-content>
        <v-container fluid>

            <panelcontainer>
                <div class="headline" slot="headline">Reçete / Finishing</div>
                <div slot="actions">
					<actions v-if="getAuth.isAdmin" module="recipes_finishings" :item="item" />
                    <v-btn tile color="indigo" dark @click="saveItem()">
                        <v-icon>{{mdiContentSave}}</v-icon> Kaydet
                    </v-btn>
                </div>
                <loading v-if="isLoading" text="Reçete bilgileri yükleniyor..." size="80" width="2" />

                <template v-if="!isLoading">
                    <v-container grid-list-md mt-3>
                        <v-layout wrap>
                            <v-flex xs6 mb-3>
                                <v-text-field label="Konu" v-model="item.title" outlined hide-details placeholder="Örn: Burnish Mutation"></v-text-field>
                            </v-flex>
                            <v-flex xs3 mb-3>
                                <v-select v-model="item.user_id" :items="users" item-value="id" item-text="fullname" label="Müşteri Adı" outlined hide-details></v-select>
                            </v-flex>
                            <v-flex xs6 md3 mb-3>
                                <datepicker label="Tarih" v-model="item.date_text" locale="tr-tr" />
                            </v-flex>
                            <v-flex xs6 md3 mb-3>
                                <v-text-field label="Ürün Adı" v-model="item.product_name" outlined hide-details placeholder="Örn: Burnish"></v-text-field>
                            </v-flex>
                            <v-flex xs6 md3 mb-3>
                                <v-text-field label="Ürün No" v-model="item.product_no" outlined hide-details placeholder="Örn: 190610-3ARBKMY"></v-text-field>
                            </v-flex>
                            <v-flex xs6 md3 mb-3>
                                <v-text-field label="Renk" v-model="item.color" outlined hide-details placeholder="Örn: KAHVERENGİ"></v-text-field>
                            </v-flex>
                            <v-flex xs6 md3 mb-3>
                                <v-text-field label="Teknisyen" v-model="item.technician" outlined hide-details placeholder="Örn: Ahmet Yesevi"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>


                    <v-container grid-list-md mt-3>
                        <v-layout wrap>
                            <v-flex xs12>
                                <table class="RecipesTable">
                                    <tbody>
                                        <tr>
                                            <td rowspan="2" align="center" valign="middle"><b>MALZEME ADI</b></td>
                                            <td colspan="6" align="center" valign="middle" height="30px"><b>FORMULASYON</b></td>
                                            <td rowspan="2" align="center" valign="middle" colspan="3"><b>AÇIKLAMA</b></td>
                                        </tr>
                                        <tr>
                                            <td class="colFmlt" v-for="fmltIndex in 6" :key="'col-'+fmltIndex" align="center" valign="middle" width="80px">{{fmltIndex}}</td>
                                        </tr>
                                        <tr v-for="(entry,entryIndex) in item.entries" :key="'itemEntry'+entryIndex" class="entryItem">
                                            <td>
                                                <input class="recipesInputtext" type="text" v-model="entry.material_name">
                                            </td>
                                            <td v-for="(step,stepIndex) in entry.steps" :key="'itemEntry'+entryIndex+'Step'+stepIndex">
                                                <input class="recipesInputnumber" type="text" v-model="entry.steps[stepIndex]">
                                            </td>
                                            <td>
                                                <input class="recipesInputtext" type="text" v-model="entry.description">
                                            </td>
                                            <td class="actions" width="1px">
                                                <v-btn small tile icon color="primary" dark @click="addEntry(entryIndex)">
                                                    <v-icon>{{mdiTableRowPlusBefore}}</v-icon>
                                                </v-btn>
                                            </td>
                                            <td class="actions" width="1px">
                                                <v-btn small tile icon color="red" dark @click="removeEntry(entryIndex)">
                                                    <v-icon>{{mdiCloseCircle}}</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" valign="middle" colspan="10" height="60px">
                                                <v-btn tile small color="green" dark @click="addEntry()"> Yeni Satır Ekle </v-btn>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="right" valign="middle"><b>TOPLAM</b></td>
                                            <td v-for="(total,totalIndex) in getTotals" :key="'total'+totalIndex" class="totalInteger">
                                                {{total}}
                                            </td>
                                            <td colspan="3"></td>
                                        </tr>
                                        <tr>
                                            <td colspan="10" class="recipesInputtextareaWrapper">
                                                <small>NOT:</small>
                                                <textarea class="recipesInputtextarea" rows="20" v-model="item.note"></textarea>
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                            </v-flex>
                        </v-layout>
                    </v-container>


                </template>
            </panelcontainer>



            <v-snackbar v-model="actionDialogShow" :color="actionDialogColor" :timeout="3000" top>
                {{ actionDialogText }}
                <v-btn dark text @click="actionDialogShow = false">
                    Tamam
                </v-btn>
            </v-snackbar>



        </v-container>
    </v-content>


</template>


<script>
    import loading from "@/components/utils/loading"
    import panelcontainer from "@/components/utils/panelcontainer"
    import inputtffloat from "@/components/inputs/tffloat"
    import datepicker from "@/components/inputs/datepicker"
    import actions from "@/components/utils/actions"
    import {
        mdiPlus,
        mdiCloseCircle,
        mdiBellCheck,
        mdiTimerSand,
        mdiEmailSend,
        mdiCalendarRange,
        mdiTableRowPlusBefore,
        mdiContentSave,
    } from '@mdi/js';
    export default {
        components: {
            loading,
            panelcontainer,
            datepicker,
            actions,
        },
        data: () => ({
            mdiPlus: mdiPlus,
            mdiCloseCircle: mdiCloseCircle,
            mdiBellCheck: mdiBellCheck,
            mdiTimerSand: mdiTimerSand,
            mdiEmailSend: mdiEmailSend,
            mdiCalendarRange: mdiCalendarRange,
            mdiTableRowPlusBefore: mdiTableRowPlusBefore,
            mdiContentSave: mdiContentSave,

            isLoading: false,
            dialogEditor: false,
            dialogRemove: false,
            users: [],
            item: {},

            actionDialogShow: false,
            actionDialogText: "",
            actionDialogColor: "",
        }),
        mounted() {
            this.item_id = this.$route.query.id || ""
            this.loadUsers()
            this.loadItem()
        },
        methods: {
            loadUsers() {
                this.$http.get(process.env.VUE_APP_API_URL + "/users/shared", {
                    params: {}
                }).then(response => {
                    this.users = response.body;
                })
            },
            loadItem() {
                this.isLoading = true;
                if (this.item_id == "") {
                    this.setNewItemData();
                    this.isLoading = false;
                } else {
                    this.$http.get(process.env.VUE_APP_API_URL + "/recipes/finishing/info", {
                        params: {
                            id: this.item_id
                        }
                    }).then(response => {
                        this.item = response.body;
                        this.isLoading = false;
                    })
                }
            },
            setNewItemData() {
                this.item = {
                    id: "",
                    title: "",
                    user_id: 0,
                    color: "",
                    product_name: "",
                    product_no: "",
                    date_text: "",
                    technician: "",
                    entries: [],
                    totals: [],
                    note: ""
                }
                for (var i = 0; i < 10; i++) {
                    this.addEntry();
                }
            },
            addEntry(before) {
                var entry = {
                    material_name: "",
                    steps: ["", "", "", "", "", ""],
                    description: ""
                }
                if (before === 0 || before > 0) {
                    this.item.entries.splice(before, 0, entry);
                } else {
                    this.item.entries.push(entry)
                }
            },
            removeEntry(i) {
                this.item.entries.splice(i, 1);
            },
            saveItem() {
                this.isLoading = true;
                var data = this.item;
                data.totals = this.getTotals;
                this.$http.post(process.env.VUE_APP_API_URL + "/recipes/finishing/save", data).then(response => {
                    if (response.body.success) {
                        this.actionDialogShow = true;
                        this.actionDialogText = "Kayıt başarılı"
                        this.actionDialogColor = "green"
                        this.$router.replace("/recipes/finishings/edit/?id=" + response.body.id)
                        setTimeout(() => {
                            location.reload();
                        }, 500)
                    } else {
                        this.actionDialogShow = true;
                        this.actionDialogText = response.body.reason
                        this.actionDialogColor = "red"
                        this.isLoading = false;
                    }
                })
            },
        },
        computed: {
            getTotals() {
                var totals = [0, 0, 0, 0, 0, 0];
                for (var i in this.item.entries) {
                    for (var s = 0; s < 6; s++) {
                        totals[s] += parseInt(this.item.entries[i].steps[s] || 0) || 0;
                    }
                }
                return totals
            },
			getAuth(){
				return this.$store.getters.getAuth;
			} 
        }
    }
</script>

<style lang="less">
    .RecipesTable {
        .colFmlt {
            color: rgb(95, 95, 95);
        }

        .totalInteger {
            text-align: center;
            color: #555;
            line-height: 30px;
        }
    }
</style>